import React from "react";

const Subtitle: React.FC = () => {
    return (
        <>
            See how your stores are performing with previous and forecasts revenue for the next year.
            Compare past revenue with future projections to spot trends and identify how your selected store is performing
        </>
    );
};

export default Subtitle;
